import { Module } from 'vuex';
import type { RootState } from '@/interfaces/store';
import $rq from '@/api/api';
import type { SiteOrder, SiteOrdersResponse } from '@/interfaces/apiInterfaces';

interface SiteOrdersState {
    orders: SiteOrder[];
    draftOrdersCount: number;
}

const defaultState: SiteOrdersState = {
    orders: [],
    draftOrdersCount: 0,
};

export const siteOrdersModule: Module<SiteOrdersState, RootState> = {
    namespaced: true,
    state: { ...defaultState },

    getters: {
        siteOrders: (state: SiteOrdersState): SiteOrder[] => state.orders,
        draftOrdersCount: (state: SiteOrdersState): number => {
            return state.draftOrdersCount;
        },
    },

    mutations: {
        setSiteOrders(state: SiteOrdersState, response: SiteOrdersResponse): void {
            state.orders = response.orders;
            const draftCount = response.orders.filter(
                (order) => order.status.toLowerCase() === 'draft',
            ).length;
            state.draftOrdersCount = draftCount;
        },
        resetSiteOrders(state: SiteOrdersState): void {
            Object.assign(state, { ...defaultState });
        },
    },

    actions: {
        async getSiteOrders({ commit }, siteId: string): Promise<void> {
            const { data } = await $rq.getSiteOrders(siteId);
            commit('setSiteOrders', data);
        },
    },
};
